<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'DASHBOARD' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">speed</mat-icon>
  </p>
  <div class="container mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      <app-managment-card [title]="'USERS_MANAGEMENT.USERS_MANAGEMENT' | translate" [textColor]="'text-white'"
        [bgColor]="'bg-blueCielNovo'" [icon]="'people_alt'" [routerLink]="'/utilisateurs-managment'">
      </app-managment-card>
      @if (!afficheChoixRoot) {
        <app-managment-card [title]="'TAGS_MANAGEMENT.TAGS_MANAGEMENT' | translate"
          [textColor]="'text-white'" [bgColor]="'bg-blueFonceNovo'" [icon]="'bookmark_added'"
          [routerLink]="'/etiquettes-managment'">
        </app-managment-card>
      }
      @if (afficheContenusPerso) {
        <app-managment-card
          [title]="'PACKAGES_PERSO_MANAGEMENT.PACKAGES_PERSO_MANAGEMENT' | translate" [textColor]="'text-white'"
          [bgColor]="'bg-vertFonceNovo'" [icon]="'settings_cinematic_blur'"
          [routerLink]="'/scorm-perso-managment'">
        </app-managment-card>
      }
      @if (afficheChoixRoot) {
        <app-managment-card
          [title]="'LIBRARIES_MANAGEMENT.LIBRARIES_MANAGEMENT' | translate" [textColor]="'text-white'"
          [bgColor]="'bg-vertClairNovo'" [icon]="'books_movies_and_music'"
          [routerLink]="'/bibliotheques-managment'">
        </app-managment-card>
      }
      @if (!afficheChoixRoot) {
        <app-managment-card
          [title]="'LEARNING_PATH_MANAGEMENT.LEARNING_PATH_MANAGEMENT' | translate" [textColor]="'text-white'"
          [bgColor]="'bg-moveFonceNovo'" [icon]="'conversion_path'"
          [routerLink]="'/parcours-formation-managment'">
        </app-managment-card>
      }
      @if (afficheChoixRoot) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-grayNovoCard'"
          [title]="'ORGANIZATIONS_MANAGEMENT.ORGANIZATIONS_MANAGEMENT' | translate"
          [routerLink]="'/organisations-managment'">
        </app-managment-card>
      }
      @if (afficheChoixRoot) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-moveFonceNovo'"
          [title]="'PARAMETRES_ORGANISATIONS_MANAGEMENT.TITLE' | translate" [icon]="'settings'"
          [routerLink]="'/parametres-organisations-managment'">
        </app-managment-card>
      }
      <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-orangeNovo'"
        [title]="'CONTENUS_MANAGEMENT.PAGE_CONTENUS_MANAGEMENT' | translate" [icon]="'monitoring'"
        [routerLink]="'/rapports'">
      </app-managment-card>
      <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-jauneNovo'"
        [title]="'CERTIFICAT_MANAGEMENT.PAGE_CERTIFICAT_MANAGEMENT' | translate" [icon]="'workspace_premium'"
        [routerLink]="'/certificats-managment'">
      </app-managment-card>
      @if (!afficheChoixRoot) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-moveNovo'"
          [title]="'GROUP_TRAINING_MANAGEMENT.PAGE_GROUP_TRAINING_MANAGEMENT' | translate" [icon]="'groups'"
          [routerLink]="'/groupes-formation-managment'">
        </app-managment-card>
      }
      @if (aAccesIndex) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-roseFonceNovo'"
          [title]="'INDEX_FORMATION.INDEX_FORMATION' | translate" [icon]="'menu_book'"
          [routerLink]="'/index-formation'">
        </app-managment-card>
      }
      @if (aAccesDiffusion) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-orangeDiffusionNovo'"
          [title]="'DIFFUSION.TITLE' | translate" [icon]="'tv'" [routerLink]="'/diffusion-managment'">
        </app-managment-card>
      }
      @if (afficheChoixRoot) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-purpleNovo'"
          [title]="'ADMINISTRATION_AVANCEE.TITLE' | translate" [icon]="'admin_panel_settings'"
          [routerLink]="'/administration-avancee-managment'">
        </app-managment-card>
      }
      @if (!afficheChoixRoot || !isModeRoot) {
        <app-managment-card [textColor]="'text-white'" [bgColor]="'bg-purpleNovo'"
          [title]="'PARAMETRE_ENTITE.TITLE' | translate" [icon]="'admin_panel_settings'"
          [routerLink]="'/parametre-entite'">
        </app-managment-card>
      }
    </div>
  </div>

</div>
